import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 6,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.406 3.866c-.062.062-.136.112-.217.146s-.168.051-.256.051-.175-.017-.256-.051-.155-.083-.217-.146L1.406.806C1.344.743 1.27.694 1.189.66S1.021.609.933.609.758.626.676.66.521.743.459.806c-.124.125-.194.294-.194.47s.07.345.194.47l3.06 3.06a2 2 0 0 0 2.827 0l3.06-3.06c.123-.124.193-.292.193-.467.001-.088-.016-.175-.049-.256S9.468.868 9.406.806 9.27.694 9.189.66 9.021.609 8.933.609s-.175.017-.256.051-.155.083-.217.146l-3.053 3.06z",
		fill: "#333"
	})
});
export default SvgDownArrow;
